/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( 'a.mec-booking-button' ).wrapInner( '<span></span>' );
      $( '.search-filter-field--control-type-submit button' ).wrapInner( '<span></span>' );
      $( '.mec-single-event-time' ).after( $( '.mec-event-data-field-items' ) );
      $( '.mec-event-data-field-items li span' ).slice( -2 ).wrapAll( '<div></div>' );
      $( '.mec-event-data-field-name' ).each( function() {
        $( this ).text( $( this ).text().replace( ':', '' ) );
      } );

      $( '.mec-event-data-field-item' ).find( 'img' ).remove();
      $( '.mec-event-data-field-item' ).prepend( '<svg class="icon size-5 text-brand-red"><use xlink:href="#icon-age"></use></svg>' );
      $( 'a.mec-nextprev-next-button' ).html( '<svg class="icon"><use xlink:href="#icon-chevron-right"></use></svg>' );
      $( 'span.mec-nextprev-prev-button' ).html( '<svg class="icon"><use xlink:href="#icon-chevron-right"></use></svg>' );

      $( '.nextpostslink' ).html( '<svg class="icon"><use xlink:href="#icon-chevron-right"></use></svg>' );
      $( '.previouspostslink' ).html( '<svg class="icon"><use xlink:href="#icon-chevron-left"></use></svg>' );

      $( 'li.sf-field-taxonomy-mec_category label' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-folder"></use></svg></span>' );
      $( 'li.sf-field-post-meta-mec_fields_1 label' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-age"></use></svg></span>' );
      $( 'li.sf-field-post-meta-event_duration label' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-duration"></use></svg></span>' );
      $( 'li.sf-field-post-meta-mec_cost label' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-price"></use></svg></span>' );
      $( 'li.sf-field-post-meta-mec_start_date label:first' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-dates"></use></svg></span>' );
      $( 'li.sf-field-search label' ).prepend( '<span class="border-r border-brand-off-white pr-3 mr-2.5 shrink-0"><svg class="icon size-5 text-brand-navy"><use xlink:href="#icon-magnifying-glass"></use></svg></span>' );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'mec', COMPONENT );
} )( app );
